import styled from 'styled-components';

const Wrapper = styled.div`
  background: url('static/grid.png');
  color: #fff;
  padding: 35px 0 15px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 70px 0 30px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  padding: 0 18px;
  max-width: 1140px;
`;

const Heading = styled.h1`
  font-size: 21px;
  line-height: 17px;
  font-weight: 500;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 30px;
    margin-bottom: 35px;
  }
`;

const Tagline = styled.p`
  font-size: 12px;
  line-height: 19px;
  opacity: 0.7;
  max-width: 622px;
  margin: 0 auto 45px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 74px;
  }
`;

const Groups = styled.div`
  @media (min-width: 1000px) {
    display: flex;
    justify-content: space-between;

    & > div {
      width: 47%;
    }
  }
`;

const Testimonial = styled.div`
  display: flex;
  margin-bottom: 35px;
  text-align: left;
  max-width: 800px;
  margin: 0 auto 35px;

  @media (min-width: 768px) {
    margin-bottom: 70px;
  }
`;

const Text = styled.p`
  font-size: 13px;
  line-height: 22px;

  span {
    display: block;
    margin-top: 15px;
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 30px;

    span {
      margin-top: 25px;
    }
  }
`;

export { Wrapper, Container, Heading, Tagline, Groups, Testimonial, Text };
